import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from './cache.service';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./cache.service";
var RankMyAgentService = /** @class */ (function () {
    function RankMyAgentService(httpClient, cache) {
        this.httpClient = httpClient;
        this.cache = cache;
        // Remax does not pay for use of this api key, so we've left it in the front end
        this.apiKey = 'jrbVr7YT9OiADr4ZGLbSh75kF4Jo5NnD8dnKMJxe5twfK80Gva05sDOQFGegOeB0';
        this.apiRoot = 'https://rankmyagent.com/API';
    }
    RankMyAgentService.prototype.getAgentRating = function (personifyId) {
        var _this = this;
        var route = this.apiRoot + "/GetAgent";
        var params = new HttpParams()
            .set('personify_id', personifyId)
            .set('key', this.apiKey);
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(!!hashValue.personify_id ? hashValue : null); // Check if cached value has any data, otherwise return null instead of {}
        }
        return this.httpClient.get(route, { params: params, withCredentials: false }).pipe(catchError(function (err) { return of(null); }), // Run catchError before caching so we can cache a 404
        tap(function (rating) { return _this.cache.set(hashKey, rating, 1000); }));
    };
    RankMyAgentService.ngInjectableDef = i0.defineInjectable({ factory: function RankMyAgentService_Factory() { return new RankMyAgentService(i0.inject(i1.HttpClient), i0.inject(i2.CacheService)); }, token: RankMyAgentService, providedIn: "root" });
    return RankMyAgentService;
}());
export { RankMyAgentService };
